import { useTranslation } from 'react-i18next';
import { FormField } from '@noor/ui';

/**
 * The hours the dish is on sale, as a «с» / «до» pair of time pickers. Both left
 * empty means it is sold all day — the placeholder says so rather than showing
 * a time. A night window (22:00–02:00) is legitimate, so the two are not
 * ordered against each other; only «both or neither» is enforced, by the schema.
 */
export function SellingHoursField({
  className,
  fieldClassName,
  labelClassName,
}: {
  className?: string;
  fieldClassName?: string;
  labelClassName?: string;
}) {
  const { t } = useTranslation('eats');
  const label = labelClassName ?? 'text-sm font-medium tracking-tight';

  return (
    <div className={className}>
      <span className={label}>{t('menu.product.form.sellingHoursLabel')}</span>
      <div className="flex items-start gap-3">
        <FormField name="availableFrom" className="flex-1 gap-1.5">
          <FormField.Label className="text-xs text-muted-foreground">
            {t('menu.product.form.sellingHoursFrom')}
          </FormField.Label>
          <FormField.TimePicker
            {...(fieldClassName ? { className: fieldClassName } : {})}
            placeholder={t('menu.product.form.sellingHoursAllDay')}
          />
          <FormField.Message />
        </FormField>
        <FormField name="availableTo" className="flex-1 gap-1.5">
          <FormField.Label className="text-xs text-muted-foreground">
            {t('menu.product.form.sellingHoursTo')}
          </FormField.Label>
          <FormField.TimePicker
            {...(fieldClassName ? { className: fieldClassName } : {})}
            placeholder={t('menu.product.form.sellingHoursAllDay')}
            allowEndOfDay
          />
          <FormField.Message />
        </FormField>
      </div>
      <span className="text-xs leading-relaxed text-muted-foreground">
        {t('menu.product.form.sellingHoursHint')}
      </span>
    </div>
  );
}
